function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0-1h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  d: "M17.429 12.344c.164 0 .285.121.285.286a.278.278 0 0 1-.285.287.278.278 0 0 1-.286-.287c0-.165.121-.286.286-.286zm0-1.148A1.44 1.44 0 0 0 16 12.63a1.44 1.44 0 0 0 1.429 1.435 1.44 1.44 0 0 0 1.428-1.435 1.44 1.44 0 0 0-1.428-1.434zm-2.858-.565h8.286v4.017h-8.286a.274.274 0 0 1-.285-.287v-3.443c0-.17.117-.287.285-.287zM1.143 4.865a2.26 2.26 0 0 0 1.143.313c6.435-.006 14.183 0 19.714 0 .485 0 .857.374.857.861v3.444h-8.286c-.781 0-1.428.65-1.428 1.435v3.443c0 .785.647 1.435 1.428 1.435h8.286v3.444c0 .487-.372.86-.857.86H2a.845.845 0 0 1-.857-.86V4.865zm1.143-3.13h17.143V4.03H2.286a1.13 1.13 0 0 1-1.143-1.148c0-.645.5-1.147 1.143-1.147zm0-1.148A2.299 2.299 0 0 0 0 2.882V19.24c0 1.103.902 2.008 2 2.008h20c1.098 0 2-.905 2-2.008V6.04a2.013 2.013 0 0 0-2-2.01h-1.429V1.16c0-.3-.272-.573-.571-.573H2.286z"
}));

const SvgIcWallet = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcWallet, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-wallet.611beffd.svg";
export { ForwardRef as ReactComponent };